import React from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, Clock, ChefHat, TrendingDown, Wallet, Utensils } from 'lucide-react';
const benefits = [{
  icon: <Dumbbell className="w-8 h-8 text-vibrantGreen" data-id="element-16" />,
  title: 'Más proteína',
  description: 'Recetas diseñadas para alcanzar tus requerimientos diarios fácilmente.'
}, {
  icon: <Clock className="w-8 h-8 text-vibrantGreen" data-id="element-17" />,
  title: 'Menos tiempo cocinando',
  description: 'Cenas listas en 15 minutos reales, sin ensuciar toda la cocina.'
}, {
  icon: <ChefHat className="w-8 h-8 text-vibrantGreen" data-id="element-18" />,
  title: 'Recetas fáciles',
  description: 'Paso a paso simple, a prueba de principiantes en la cocina.'
}, {
  icon: <TrendingDown className="w-8 h-8 text-vibrantGreen" data-id="element-19" />,
  title: 'Ideal para perder grasa',
  description: 'Macros calculados y porciones exactas para déficit calórico.'
}, {
  icon: <Wallet className="w-8 h-8 text-vibrantGreen" data-id="element-20" />,
  title: 'Ingredientes económicos',
  description: 'Sin ingredientes raros ni caros. Todo lo consigues en el súper.'
}, {
  icon: <Utensils className="w-8 h-8 text-vibrantGreen" data-id="element-21" />,
  title: 'Perfecto para meal prep',
  description: 'Opciones que puedes guardar y recalentar sin que pierdan sabor.'
}];
export function Benefits() {
  return <section className="py-24 md:py-28 bg-lightGreen" data-id="element-22">
      <div className="container mx-auto px-4" data-id="element-23">
        <div className="text-center mb-16 md:mb-20" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-black text-darkGreen mb-6 font-montserrat uppercase" data-id="element-25">
            ¿Por qué este recetario es{' '}
            <span className="text-vibrantGreen" data-id="element-26">Diferente</span>?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-27">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-100 group" data-id="element-28">
              <div className="w-16 h-16 bg-lightGreen rounded-2xl flex items-center justify-center mb-6 group-hover:bg-vibrantGreen/20 transition-colors" data-id="element-29">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-darkGreen mb-3 font-montserrat" data-id="element-30">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-31">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}